import hyperdom from 'hyperdom'
import {PassengersBooking} from '../../../defaultFlow/index.js'
import format from 'root-core/utils/text/stringFormatFilter.js'

export default class PassengersBookingDayTour extends PassengersBooking {
  constructor (options) {
    super(options)
  }

  renderTourOnRequestWarning () {
    const message = hyperdom.rawHtml('p', format(this.config.passengersBookingMessages.dayTourOnRequest, this.config.phone.general))
    return <div>
      {message}
    </div>
  }
}
